import { createService } from '@/helpers/hasura'

const output = `
  web_form_id
  file_id
`
const allowedFields = ['file_id', 'web_form_id']

export default config => {
  const { client } = config

  const service = createService({
    ...config,
    table: 'web_form_file',
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: '',
    defaultOrderBy: [{ submitted_at: 'desc' }],
    allowedFields,
    uniqueFields: []
  })

  return {
    ...service
  }
}
